import { AwsUi } from '../../../core/runtime/src';
import { Autosuggest } from '../../input/src';
import TagControlController from './controllers/tag-control-controller';
export var TagControl = AwsUi.__addComponent('awsui-tag-control', {
    releaseStatus: 'internal',
    properties: {
        value: {
            type: 'string'
        },
        limit: {
            type: 'integer'
        },
        options: {
            type: 'array',
            itemTypes: ['Autosuggest.Option']
        },
        readonly: {
            type: 'boolean'
        },
        doRequest: {
            type: 'function',
            functionType: 'TagEditor.RequestFunction'
        },
        placeholder: {
            type: 'string'
        },
        suggestionText: {
            type: 'string'
        },
        tooManySuggestionText: {
            type: 'string'
        },
        loadingText: {
            type: 'string'
        },
        errorText: {
            type: 'string'
        },
        status: {
            type: 'string'
        },
        loadingError: {
            type: 'boolean',
            defaultValue: false
        }
    },
    callbacks: {
        initialized: function () {
            this.__controller = new TagControlController(this);
        }
    },
    events: {
        input: {
            bubbles: true,
            cancelable: false,
            detailType: 'Input.ChangeDetail'
        },
        delayedInput: {
            bubbles: true,
            cancelable: false,
            detailType: 'Input.ChangeDetail'
        },
        blur: {
            bubbles: true,
            cancelable: false
        }
    },
    render: function () {
        return (AwsUi.__createElement(Autosuggest, { placeholder: this.placeholder, readonly: this.readonly, value: this.value, empty: this.__controller.getSuggestion(), options: this.__controller.getOptions(), errorText: this.__controller.getErrorStatusText(), loadingText: this.__controller.getLoadingStatusText(), statusType: this.__controller.getStatusType(), input: this.__controller.inputHandler.bind(this.__controller), delayedInput: this.__controller.delayedInputHandler.bind(this.__controller), blur: this.__controller.keyBlurHandler.bind(this.__controller), focus: this.__controller.focusHandler.bind(this.__controller), __openOnFocus: true }));
    }
});
//# sourceMappingURL=tag-control.js.map